// removed by extract-text-webpack-plugin
module.exports = {"alert":"_3spBglZH59K4sf7N-2N9cu"};


/*****************
 ** WEBPACK FOOTER
 ** ../app/Components/Survey/Alert/styles.scss
 ** module id = 417
 ** module chunks = 0
 **/